var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "136.4%",
    height: "135%",
    x: "-18.7%",
    y: "-12.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M577 77.074l2.358-1.839c.72.131 1.329.21 1.824.239 1.076-.412 1.834-1.125 2.274-2.14.44-1.016.66-2.557.66-4.625l.056-2.176c0-2.797.954-4.987 2.863-6.568 1.59-1.31 3.27-1.965 5.039-1.965.758 0 1.534.173 2.33.52l-2.078 2.034c-.851-.552-1.693-.828-2.526-.828-2.087 0-3.13 1.708-3.13 5.123l-.056 1.937c0 2.648-.253 4.587-.758 5.818-.505 1.23-1.474 2.247-2.905 3.052l2.905.239 1.291.098 1.558.098c.412.028.875.042 1.39.042 2.32 0 4.13-.673 5.431-2.02.15.186.225.322.225.406 0 .31-.45.838-1.347 1.586-1.535 1.263-3.182 1.895-4.94 1.895-.721 0-1.606-.037-2.653-.112l-4.169-.31c-2.17-.158-4.051-.327-5.642-.504z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(-575 -57)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5f00a0",
    xlinkHref: "#prefix__b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLLogo);
export default __webpack_public_path__ + "static/media/l_logo.3345d7d53584b29612a09da73e9f9990.svg";
export { ForwardRef as ReactComponent };